const SAVE_CARD_ENDPOINT = '/myaccount/savecardtoprofile';
const COMMERCIAL_SAVE_CARD_ENDPOINT = '/myaccount/commercialsavecardtoprofile';

const defaultPromoInfo = {
  applianceDfp: '_2D3',
  crcDfp: '_C3T',
  everydayDfp: '_1D3',
  tieredApplianceDfp: '_3DF',
  tieredDfp: '_FD3',
  twelveMonthsSpecialDfp: '_BD3',
  appliancePromoDates: {},
  tieredApplianceDates: {},
  tieredPromoDates: {},
  twelveMonthSpecialPromoDates: {}
};

const EVERYDAY_FINANCING_MONTHS = 6;
const SPECIAL_FINANCING_MONTHS = 12;
const APPLIANCE_FINANCING_MONTHS = 12;
const TIERED_PROMO_TIERS = [
  {
    minAmount: 299,
    maxAmount: 999,
    tierInMonths: 12
  },
  {
    minAmount: 999,
    maxAmount: 1999,
    tierInMonths: 18
  },
  {
    minAmount: 1999,
    tierInMonths: 24
  }
];

export const EVERYDAY_PROMOTION = 'Everyday';
export const SPECIAL_PROMOTION = 'Special';
export const TIERED_PROMOTION = 'Tiered';
export const APPLIANCE_PROMOTION = 'Appliance';
export const TIERED_APPLIANCE_PROMOTION = 'Tiered Appliance';

const getIndexofDate = function (dateData) {
  let todayDate = new Date();
  for (let i = 0; i < dateData.length; i += 1) {
    let promotionDate = dateData[i];
    let promoStartDate = new Date(promotionDate.startDate);
    let promoEndDate = new Date(promotionDate.endDate);
    promoEndDate.setHours(23, 59, 59);
    if (promoStartDate <= todayDate && todayDate <= promoEndDate) {
      return i;
    }
  }
  return -1;
};

const getStringDate = (unformattedDate) => {
  const date = new Date(unformattedDate);
  return date.toLocaleString('en-us', { dateStyle: 'short' });
};

const getPromotionDates = function (promoDateData) {
  let promoDates = {};
  const currentPromo = getIndexofDate(promoDateData);
  if (currentPromo > -1) {
    promoDates.activeStartDate = getStringDate(promoDateData[currentPromo].startDate);
    promoDates.activeEndDate = getStringDate(promoDateData[currentPromo].endDate);
  }
  return promoDates;
};

const getBaseUrl = function (isB2B) {
  let originUrl = window.location.href;
  let insideCheckout = originUrl.includes('checkout');
  if (window.location.href.indexOf('?') > -1) {
    originUrl = window.location.href.substring(0, window.location.href.indexOf('?'));
  }
  const endpoint = isB2B ? COMMERCIAL_SAVE_CARD_ENDPOINT : SAVE_CARD_ENDPOINT;
  const siteIdParam = isB2B ? '&siteId=PLCR_HOMEDEPOT' : '';
  return window.location.origin + endpoint + '?originUrl=' + encodeURIComponent(originUrl)
    + '&step=initial&insideCheckout=' + insideCheckout + siteIdParam + '&cmp=';
};

const generateApplyNowURL = (campaignCode, isMobile, DFP, isB2B = false) => {
  return getBaseUrl(isB2B) + (isMobile ? 'C' : 'A') + campaignCode + DFP;
};

const estimatedPaymentsFromTiers = function (price, tiers) {
  let months = EVERYDAY_FINANCING_MONTHS;
  tiers.forEach(function (tier) {
    const minAmount = tier.minAmount;
    const maxAmount = tier.maxAmount ? tier.maxAmount : '';
    if ((maxAmount && (price >= minAmount && price < maxAmount))
      || (!maxAmount && (price >= minAmount))) {
      months = tier.tierInMonths;
    }
  });
  return {
    financingMonths: months,
    monthlyPayment: Math.ceil(price / months).toLocaleString()
  };
};

const estimatedPayments = (price, months) => {
  return {
    financingMonths: months,
    monthlyPayment: Math.ceil(price / months).toLocaleString()
  };
};

export const getDefaultApplyNowURL = (contentfulInfo, campaignCode, isMobile, isB2B = false) => {
  const promoInfo = contentfulInfo?.component || defaultPromoInfo;
  return generateApplyNowURL(campaignCode, isMobile, isB2B ? promoInfo.crcDfp : promoInfo.everydayDfp, isB2B);
};

export const getPaymentEstimatorDetails = (contentfulInfo, campaignCode, isMobile, isAppliance, price) => {
  const promoInfo = contentfulInfo || defaultPromoInfo;
  const {
    applianceDfp,
    everydayDfp,
    tieredApplianceDfp,
    tieredDfp,
    twelveMonthsSpecialDfp,
    appliancePromoDates,
    tieredApplianceDates,
    tieredPromoDates,
    twelveMonthSpecialPromoDates
  } = promoInfo;

  if (getPromotionDates(tieredPromoDates).activeStartDate) {
    return {
      activePromotion: TIERED_PROMOTION,
      applyNowUrl: generateApplyNowURL(campaignCode, isMobile, tieredDfp),
      ...getPromotionDates(tieredPromoDates),
      ...(price && estimatedPaymentsFromTiers(price, TIERED_PROMO_TIERS))
    };
  } if (isAppliance && getPromotionDates(tieredApplianceDates).activeStartDate) {
    return {
      activePromotion: TIERED_APPLIANCE_PROMOTION,
      applyNowUrl: generateApplyNowURL(campaignCode, isMobile, tieredApplianceDfp),
      ...getPromotionDates(tieredApplianceDates),
      ...(price && estimatedPaymentsFromTiers(price, TIERED_PROMO_TIERS))
    };
  } if (getPromotionDates(twelveMonthSpecialPromoDates).activeStartDate) {
    return {
      activePromotion: SPECIAL_PROMOTION,
      applyNowUrl: generateApplyNowURL(campaignCode, isMobile, twelveMonthsSpecialDfp),
      ...getPromotionDates(twelveMonthSpecialPromoDates),
      ...(price && estimatedPayments(price, SPECIAL_FINANCING_MONTHS))
    };
  } if (isAppliance && getPromotionDates(appliancePromoDates).activeStartDate) {
    return {
      activePromotion: APPLIANCE_PROMOTION,
      applyNowUrl: generateApplyNowURL(campaignCode, isMobile, applianceDfp),
      ...getPromotionDates(appliancePromoDates),
      ...(price && estimatedPayments(price, APPLIANCE_FINANCING_MONTHS))
    };
  }
  return {
    activePromotion: EVERYDAY_PROMOTION,
    applyNowUrl: generateApplyNowURL(campaignCode, isMobile, everydayDfp),
    ...(price && estimatedPayments(price, EVERYDAY_FINANCING_MONTHS))
  };
};

export const getPrequalOfferLink = (contentfulInfo, campaignCode, isMobile, invitationNumber) => {
  const promoInfo = contentfulInfo?.component || defaultPromoInfo;
  const sequenceNbrParameter = invitationNumber ? '&uid=' + invitationNumber : '';
  return generateApplyNowURL(campaignCode, isMobile, promoInfo.everydayDfp)
    + '&sc=30062&app=preapp' + sequenceNbrParameter;
};
